import Vue from 'vue'
import svgIcon from 'vue-svg-icon-component'
import 'vue-svg-icon-component/lib/svg-icon.css'

Vue.use(svgIcon)
